// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./20260423151836-create-options.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/migrations/20260423151836-create-options.js"); } },
  "./20260807120000-create-local-replica.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/migrations/20260807120000-create-local-replica.js"); } },
  "./20260919130000-create-project-replica-registry.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/migrations/20260919130000-create-project-replica-registry.js"); } },
  "./20260924163000-add-project-automation-assignable.js": { enumerable: true, get() { return require("/home/dev/awesome-tasks/releases/20261103111801/frontend/src/database/migrations/20260924163000-add-project-automation-assignable.js"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;